import {
  ADD_LIST
  //   USER_INFO,
  //   SET_GROUP,
  //   CREATE_GROUP
} from './mutation-types.js'

export default {
  [ADD_LIST] (state, obj) {
    state.list.push(obj)
  }

}
